import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ESeverity } from '../../../utils/enums';

@Component({
  selector: 'app-mb-severity-tag',
  imports: [
    CommonModule
  ],
  templateUrl: './mb-severity-tag.component.html',
})
export class MbSeverityTagComponent {
  @Input() severity: ESeverity = ESeverity.LOW;

  getStyles(): string {
    switch (this.severity) {
      case ESeverity.LOW:
        return 'bg-mbaza-gray-very-light text-mbaza-gray-dark';
      case ESeverity.MEDIUM:
        return 'bg-mbaza-orange text-white';
      case ESeverity.HIGH:
        return 'bg-mbaza-text-red text-white';
      default:
        return 'bg-mbaza-gray-light';
    }
  }
}
